import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../service/auth/auth.service';

// Plateforme zone (/plateforme/**): signed in + platform right (main:federations:read). No chosen federation needed.
export const PlatformGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!auth.isAuthenticated()) return router.parseUrl('/federation/auth/login');
  if (auth.hasPlatformRights()) return true;
  return router.parseUrl(auth.needsFederation() ? '/federation/auth/select-federation' : '/federation/dashboard');
};
